import lazyImageObserver from './lazyObserver';
import constant from './constant';
import type { App } from 'vue';

const plugin = {
  install: (app: App) => {
    app.directive('lazyload', {
      /**
       * @param el
       */
      beforeMount(el: any) {
        if ('IntersectionObserver' in window) {
          lazyImageObserver.observe(el);
        }
      },
      /**
       * @param el
       */
      updated(el) {
        // when image changed
        // expecting has been loaded image before
        if ('IntersectionObserver' in window) {
          if (el.classList.contains(constant._V_LOADED)) {
            lazyImageObserver.observe(el);
          }
        }
      },
    });
  },
};

export default plugin;
